module.exports = __webpack_public_path__ + "static/media/catalx_main@2x.426d04fc.jpg";